"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.filterToNoChatLetgoCopyMap = exports.conversationUserPresence = exports.VERY_GOOD_OFFER = exports.USER_TYPE = exports.THEMES = exports.SUPPORTED_TYPES = exports.SUPPORTED_AUTO_REPLY_MESSAGE_TYPES = exports.SUGGESTIONS_VISIBILE_LIMIT = exports.SMART_CTA = exports.SHEET_HEIGHT = exports.SHARE_PHONE = exports.SELLER = exports.REPLY_RESTRICTION_NEW_USER = exports.REPLY = exports.REJECTED = exports.QUICK_FILTERS_ACTION_MAP = exports.QUICK_FILTERS = exports.QUESTION_TYPES = exports.QUESTIONS_CLOUD_CATEGORIES = exports.PRICING_ENGINE = exports.PRICE_ENGINE_CATEGORIES = exports.POPULAR = exports.PHONE_NUMBER_REPLY = exports.PEEK_HEIGHT_ISTYPING = exports.PEEK_HEIGHT = exports.OUTLINE_FACTOR = exports.ON = exports.OFF = exports.NONE = exports.MESSAGE_TTL_DAYS = exports.MEETING_TYPE = exports.MEETING_SHEET_HEIGHT = exports.LOW_OFFER = exports.KYC_REPLY_RESTRICTION_SELLER_METADATA = exports.KYC_REPLY_RESTRICTION_SELLER_LIMIT = exports.KYC_REPLY_RESTRICTION_SELLER = exports.KYC_REPLY_RESTRICTION_METADATA = exports.KYC_REPLY_RESTRICTION_LIMIT = exports.KYC_REPLY_RESTRICTION = exports.KYC_REPLY_COUNT = exports.KYC_EXPERIMENT_SELLER = exports.KYC_EXPERIMENT = exports.IS_SELLER_KYC_POPUP_SHOWN = exports.INBOX_AUTO_REPLY_CARD_VIEWED = exports.HIGH_OFFER = exports.GOOD_OFFER = exports.FOFO = exports.DS_MODEL_OFFER = exports.DELETE_USER_DIALOG_LETGO = exports.DELETE_USER_DIALOG = exports.DELETE_CHAT_TITLE = exports.DELETE_CHAT_MODAL = exports.DELETE_CHAT_CONFIRM = exports.DELETE = exports.DEFAULT_LISTING_ROUTES = exports.DEFAULT = exports.CUSTOM_REPLY = exports.CROWN = exports.COCO = exports.CANCEL = exports.BUYER = exports.BIFROST_STORED_DATA_TIME = exports.BIFROST_STORED_DATA = exports.BIFROST_LANG = exports.BIFROST_FEATURES = exports.AUTO_REPLY_VISIBLE_IN_CURRENT_SESSION = exports.AUTO_REPLY_ONBOARDING_KEY = exports.AUTO_REPLY_CATEGORIES = exports.AUTO_REPLY_ANIMATION_DURATION = exports.AUTO_REPLY = exports.API_CALL_DELAY = exports.ACCOUNT_CREATED = exports.ACCEPTED = void 0;
var AUTO_REPLY = exports.AUTO_REPLY = 'auto_reply';
var AUTO_REPLY_ANIMATION_DURATION = exports.AUTO_REPLY_ANIMATION_DURATION = 1000;
var OUTLINE_FACTOR = exports.OUTLINE_FACTOR = 1000;
var SELLER = exports.SELLER = 'seller';
var BUYER = exports.BUYER = 'buyer';
var QUESTION_TYPES = exports.QUESTION_TYPES = ['peer'];
var SUPPORTED_AUTO_REPLY_MESSAGE_TYPES = exports.SUPPORTED_AUTO_REPLY_MESSAGE_TYPES = ['text', 'actionable', 'image', 'location'];
var CROWN = exports.CROWN = 'crown';
var SHARE_PHONE = exports.SHARE_PHONE = 'sharePhone';
var PHONE_NUMBER_REPLY = exports.PHONE_NUMBER_REPLY = 'phoneNumberReply';
var REPLY = exports.REPLY = 'reply';
var BIFROST_FEATURES = exports.BIFROST_FEATURES = '_bifro_features';
var BIFROST_STORED_DATA_TIME = exports.BIFROST_STORED_DATA_TIME = '_bifro_storedDataTime';
var BIFROST_STORED_DATA = exports.BIFROST_STORED_DATA = '_bifro_storedData';
var BIFROST_LANG = exports.BIFROST_LANG = '_bifro_lang';
var MESSAGE_TTL_DAYS = exports.MESSAGE_TTL_DAYS = 'message_ttl_days';
var QUESTIONS_CLOUD_CATEGORIES = exports.QUESTIONS_CLOUD_CATEGORIES = 'question_categories';
var SUGGESTIONS_VISIBILE_LIMIT = exports.SUGGESTIONS_VISIBILE_LIMIT = 'suggestions_visible_limit';
var AUTO_REPLY_CATEGORIES = exports.AUTO_REPLY_CATEGORIES = 'auto_reply_categories';
var OFF = exports.OFF = 'off';
var ON = exports.ON = 'on';
var SMART_CTA = exports.SMART_CTA = 'smart_cta';
var CUSTOM_REPLY = exports.CUSTOM_REPLY = 'custom_reply';
var PRICING_ENGINE = exports.PRICING_ENGINE = 'pricing_engine';
var PRICE_ENGINE_CATEGORIES = exports.PRICE_ENGINE_CATEGORIES = 'pricing_engine_categories';
var INBOX_AUTO_REPLY_CARD_VIEWED = exports.INBOX_AUTO_REPLY_CARD_VIEWED = 'isAutoReplyFeatureInboxCardViewed';
var AUTO_REPLY_ONBOARDING_KEY = exports.AUTO_REPLY_ONBOARDING_KEY = 'auto_reply_inbox_onboarding';
var AUTO_REPLY_VISIBLE_IN_CURRENT_SESSION = exports.AUTO_REPLY_VISIBLE_IN_CURRENT_SESSION = 'auto_reply_visible_in_session';
var DEFAULT = exports.DEFAULT = 'default';

/* offer type */
var NONE = exports.NONE = 'none';
var REJECTED = exports.REJECTED = 'rejected_offer';
var LOW_OFFER = exports.LOW_OFFER = 'low_offer';
var GOOD_OFFER = exports.GOOD_OFFER = 'good_offer';
var VERY_GOOD_OFFER = exports.VERY_GOOD_OFFER = 'very_good_offer';
var HIGH_OFFER = exports.HIGH_OFFER = 'high_offer';
var ACCEPTED = exports.ACCEPTED = 'accepted';
var DS_MODEL_OFFER = exports.DS_MODEL_OFFER = 'ds_model_offer';
var PEEK_HEIGHT = exports.PEEK_HEIGHT = 52;
var PEEK_HEIGHT_ISTYPING = exports.PEEK_HEIGHT_ISTYPING = 108;
var SHEET_HEIGHT = exports.SHEET_HEIGHT = 270;
var MEETING_SHEET_HEIGHT = exports.MEETING_SHEET_HEIGHT = 304;

/* KYC Reply restriction */
var KYC_REPLY_RESTRICTION = exports.KYC_REPLY_RESTRICTION = 'kyc_reply_restriction';
var KYC_REPLY_RESTRICTION_SELLER = exports.KYC_REPLY_RESTRICTION_SELLER = 'kyc_reply_restriction_seller';
var KYC_REPLY_RESTRICTION_LIMIT = exports.KYC_REPLY_RESTRICTION_LIMIT = 'kyc_reply_restriction_limits';
var KYC_REPLY_RESTRICTION_SELLER_LIMIT = exports.KYC_REPLY_RESTRICTION_SELLER_LIMIT = 'kyc_reply_restriction_seller_limits';
var KYC_REPLY_COUNT = exports.KYC_REPLY_COUNT = 'kyc_reply_count';
var KYC_EXPERIMENT = exports.KYC_EXPERIMENT = 'kyc_experiment';
var KYC_EXPERIMENT_SELLER = exports.KYC_EXPERIMENT_SELLER = 'kyc_experiment_seller';
var KYC_REPLY_RESTRICTION_METADATA = exports.KYC_REPLY_RESTRICTION_METADATA = 'kyc_reply_restriction_metadata';
var KYC_REPLY_RESTRICTION_SELLER_METADATA = exports.KYC_REPLY_RESTRICTION_SELLER_METADATA = 'kyc_reply_restriction_seller_metadata';
var API_CALL_DELAY = exports.API_CALL_DELAY = 'apiCallDelay';
var POPULAR = exports.POPULAR = 'popular';
var FOFO = exports.FOFO = 'fofo';
var COCO = exports.COCO = 'coco';
var SUPPORTED_TYPES = exports.SUPPORTED_TYPES = ['share_image', 'share_location', 'text', 'request_callback', 'request_meeting_v3'];
var IS_SELLER_KYC_POPUP_SHOWN = exports.IS_SELLER_KYC_POPUP_SHOWN = 'isSellerKycPopupShown';
var DELETE_CHAT_TITLE = exports.DELETE_CHAT_TITLE = 'deleteChatTitle';
var DELETE_USER_DIALOG_LETGO = exports.DELETE_USER_DIALOG_LETGO = 'deleteUserDialogLetgo';
var DELETE_USER_DIALOG = exports.DELETE_USER_DIALOG = 'deleteUserDialog';
var DELETE = exports.DELETE = 'delete';
var CANCEL = exports.CANCEL = 'cancel';
var DELETE_CHAT_MODAL = exports.DELETE_CHAT_MODAL = 'deleteChatModal';
var DELETE_CHAT_CONFIRM = exports.DELETE_CHAT_CONFIRM = 'deleteChatConfirm';
var QUICK_FILTERS = exports.QUICK_FILTERS = {
  ALL: 'all',
  MEETING: 'meeting',
  UNREAD: 'unread',
  IMPORTANT: 'important'
};
var QUICK_FILTERS_ACTION_MAP = exports.QUICK_FILTERS_ACTION_MAP = {
  all: 'ALL',
  meeting: 'MEETING',
  unread: 'UNREAD',
  important: 'IMPORTANT'
};
var THEMES = exports.THEMES = {
  LETGO: 'letgo',
  OLX: 'olx',
  OTOPLUS: 'otoplus'
};
var DEFAULT_LISTING_ROUTES = exports.DEFAULT_LISTING_ROUTES = {
  olxid: '/mobil-bekas_c198',
  olxmx: '/autos_c84',
  olxtr: '/autos_c84',
  olxcl: '/autos_c84'
};
var filterToNoChatLetgoCopyMap = exports.filterToNoChatLetgoCopyMap = {
  all: 'noAllChatsLetgo',
  unread: 'noUnreadChatsLetgo',
  important: 'noImportantChatsLetgo'
};
var conversationUserPresence = exports.conversationUserPresence = {
  unavailable: 'unavailable',
  paused: 'paused'
};
var MEETING_TYPE = exports.MEETING_TYPE = {
  // Todo: map all type values for HOME TEST DRIVE
  HOME: '',
  STORE: 'meeting_c2b',
  STORE_VISIT: 'meeting_store_visit',
  HOME_STORE: 'meeting_home_test_drive'
};
var USER_TYPE = exports.USER_TYPE = {
  COCO: 'OLX_Autos',
  FOFO: 'Franchise',
  PREFFERED: 'preffered',
  REGULAR: 'regular'
};
var ACCOUNT_CREATED = exports.ACCOUNT_CREATED = 'account_created';
var REPLY_RESTRICTION_NEW_USER = exports.REPLY_RESTRICTION_NEW_USER = 'reply_restriction_new_user';